export const maskCPF = (value: string): string => {
  // Remove any non-digit characters
  const cleaned = value.replace(/\D/g, "");

  // Apply the CPF mask dynamically
  if (cleaned.length <= 3) {
    return cleaned; // Return as is for the first 3 digits
  } else if (cleaned.length <= 6) {
    return `${cleaned.slice(0, 3)}.${cleaned.slice(3)}`; // Add first dot
  } else if (cleaned.length <= 9) {
    return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`; // Add second dot
  } else {
    return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9, 11)}`; // Add dash
  }
};

export const maskCep = (text) => {
    let text2 = text.replace('-', '');


    let final_num = '';

    for (let i = 0; i < text2.length && i < 8; i++) {
        // if (Number.isInteger(text[i])) {
        if (!isNaN(text2[i])) {

            if (i == 5) {
                final_num += '-' + text2[i];
            }
            else {
                final_num += text2[i] + '';
            }
        }
        // }
    }
    return final_num;
    // this.setState({ cep: final_num });

}

export const maskCpfCnpj = (text) => {
    let text2 = text.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '');

    let final_num = '';
    if (text2.length <= 11) {
        for (let i = 0; i < text2.length && i < 11; i++) {
            // if (Number.isInteger(text[i])) {
            if (!isNaN(text2[i])) {

                if (i == 3) {
                    final_num += '.' + text2[i];
                }
                else if (i == 6) {
                    final_num += '.' + text2[i];
                }
                else if (i == 9) {
                    final_num += '-' + text2[i];
                }
                else {
                    final_num += text2[i] + '';
                }
            }
            // }
        }
    }
    else {
        // 35.590.099/0001-03
        for (let i = 0; i < text2.length && i < 14; i++) {
            // if (Number.isInteger(text[i])) {
            if (!isNaN(text2[i])) {

                if (i == 2) {
                    final_num += '.' + text2[i];
                }
                else if (i == 5) {
                    final_num += '.' + text2[i];
                }
                else if (i == 8) {
                    final_num += '/' + text2[i];
                }
                else if (i == 12) {
                    final_num += '-' + text2[i];
                }
                else {
                    final_num += text2[i] + '';
                }
            }
            // }
        }
    }

    return final_num;
    // this.setState({ cpf: final_num });
}


export const isValidCPF = (cpf: string | null): boolean => {
  if (!cpf) return false;

  // Remove any non-digit characters
  const cleaned = cpf.replace(/\D/g, "");

  // Check if the CPF has 11 digits
  if (cleaned.length !== 11) return false;

  // Check for repeated digits (e.g., 111.111.111-11)
  if (/^(\d)\1{10}$/.test(cleaned)) return false;

  // Validate the CPF using the algorithm
  let sum = 0;
  let remainder;

  // Validate the first digit
  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cleaned.charAt(i - 1)) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  if (remainder !== parseInt(cleaned.charAt(9))) {
    return false;
  }

  // Reset sum for the second digit
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cleaned.charAt(i - 1)) * (12 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  if (remainder !== parseInt(cleaned.charAt(10))) {
    return false;
  }

  return true; // CPF is valid
};

export const maskPhone = (value: string): string => {
  // Remove any non-digit characters
  const cleaned = value.replace(/\D/g, "");

  // Format the phone number
  if (cleaned.length <= 2) {
    return cleaned; // Return as is for the first 2 digits (DDD)
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`; // Add DDD
  } else if (cleaned.length <= 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`; // Add dash
  } else {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7, 11)}`; // Format for 11 digits
  }
};

export const maskNumberInteger = (text2:string) => {
    console.log(text2);

    text2 = text2.replace(/\./g,'');
    console.log(text2);
    let final_num = '';
    for (let i = 0; i < text2.length; i++) {
        
        if ((!isNaN(text2[i]) && text2[i]!=' ') || (text2[i] == '.' && !final_num.includes('.'))) {
            final_num += text2[i] + '';
        }
    }
    return final_num;
}

export const isValidEmail = (email: string | null): boolean => {
  if (!email) return false;

  // Regular expression for validating email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidPhone = (phone: string | null): boolean => {
  if (!phone) return false;

  // Remove any non-digit characters
  const cleaned = phone.replace(/\D/g, "");

  // Check if the phone number has the correct length
  // DDD + 9 digits (for mobile) or 8 digits (for landline)
  return cleaned.length === 10 || cleaned.length === 11; // 10 for landline, 11 for mobile
}; 

/**
 * Aplica uma máscara personalizada a um valor
 * @param value - O valor a ser mascarado
 * @param mask - A máscara a ser aplicada (ex: "###.###.###-##", "(##) #####-####")
 * @returns O valor com a máscara aplicada
 * 
 * Caracteres especiais da máscara:
 * # - Representa um dígito numérico
 * A - Representa uma letra maiúscula
 * a - Representa uma letra minúscula
 * X - Representa qualquer caractere alfanumérico
 * Outros caracteres são mantidos como literais na máscara
 */
export const applyMask = (value: string, mask: string): string => {
  if (!mask || !value) return value;

  let maskedValue = '';
  let valueIndex = 0;
  
  for (let maskIndex = 0; maskIndex < mask.length && valueIndex < value.length; maskIndex++) {
    const maskChar = mask[maskIndex];
    const valueChar = value[valueIndex];
    
    switch (maskChar) {
      case '#':
        // Aceita apenas dígitos
        if (/\d/.test(valueChar)) {
          maskedValue += valueChar;
          valueIndex++;
        } else {
          // Se o caractere não é um dígito, pula para o próximo caractere do valor
          valueIndex++;
          maskIndex--; // Mantém a posição da máscara
        }
        break;
        
      case 'A':
        // Aceita apenas letras maiúsculas
        if (/[A-Z]/.test(valueChar)) {
          maskedValue += valueChar;
          valueIndex++;
        } else if (/[a-z]/.test(valueChar)) {
          // Converte para maiúscula
          maskedValue += valueChar.toUpperCase();
          valueIndex++;
        } else {
          // Se não é uma letra, pula para o próximo caractere
          valueIndex++;
          maskIndex--; // Mantém a posição da máscara
        }
        break;
        
      case 'a':
        // Aceita apenas letras minúsculas
        if (/[a-z]/.test(valueChar)) {
          maskedValue += valueChar;
          valueIndex++;
        } else if (/[A-Z]/.test(valueChar)) {
          // Converte para minúscula
          maskedValue += valueChar.toLowerCase();
          valueIndex++;
        } else {
          // Se não é uma letra, pula para o próximo caractere
          valueIndex++;
          maskIndex--; // Mantém a posição da máscara
        }
        break;
        
      case 'X':
        // Aceita qualquer caractere alfanumérico
        if (/[A-Za-z0-9]/.test(valueChar)) {
          maskedValue += valueChar;
          valueIndex++;
        } else {
          // Se não é alfanumérico, pula para o próximo caractere
          valueIndex++;
          maskIndex--; // Mantém a posição da máscara
        }
        break;
        
      default:
        // Caractere literal da máscara
        if (valueChar === maskChar) {
          // Se o caractere do valor coincide com o literal, adiciona
          maskedValue += maskChar;
          valueIndex++;
        } else {
          // Se não coincide, adiciona o literal da máscara e não avança no valor
          maskedValue += maskChar;
        }
        break;
    }
  }
  
  return maskedValue;
};

/**
 * Remove a máscara de um valor, mantendo apenas os caracteres válidos
 * @param value - O valor mascarado
 * @param mask - A máscara original
 * @returns O valor sem a máscara
 */
export const removeMask = (value: string, mask: string): string => {
  if (!mask || !value) return value;

  let unmaskedValue = '';
  
  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    const maskChar = mask[i % mask.length];
    
    // Se o caractere da máscara é um placeholder (#, A, a, X), mantém o caractere
    if (['#', 'A', 'a', 'X'].includes(maskChar)) {
      unmaskedValue += char;
    }
    // Se não é um placeholder, verifica se é um caractere literal que deve ser removido
    // (não adiciona ao valor final)
  }
  
  return unmaskedValue;
};

/**
 * Valida se uma senha atende aos critérios de segurança
 * @param password - A senha a ser validada
 * @param options - Opções de validação
 * @returns Objeto com resultado da validação e mensagens de erro
 */
export interface PasswordValidationOptions {
  minLength?: number;
  requireUppercase?: boolean;
  requireLowercase?: boolean;
  requireNumbers?: boolean;
  requireSpecialChars?: boolean;
  specialChars?: string;
}

export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
  strength: 'weak' | 'medium' | 'strong';
}

export const validatePassword = (
  password: string, 
  options: PasswordValidationOptions = {}
): PasswordValidationResult => {
  const {
    minLength = 8,
    requireUppercase = true,
    requireLowercase = true,
    requireNumbers = true,
    requireSpecialChars = true,
    specialChars = '!@#$%^&*()_+-=[]{}|;:,.<>?'
  } = options;

  const errors: string[] = [];
  let strengthScore = 0;

  // Verificar comprimento mínimo
  if (password.length < minLength) {
    errors.push(`A senha deve ter pelo menos ${minLength} caracteres`);
  } else {
    strengthScore += 1;
  }

  // Verificar letra maiúscula
  if (requireUppercase && !/[A-Z]/.test(password)) {
    errors.push('A senha deve conter pelo menos uma letra maiúscula');
  } else if (/[A-Z]/.test(password)) {
    strengthScore += 1;
  }

  // Verificar letra minúscula
  if (requireLowercase && !/[a-z]/.test(password)) {
    errors.push('A senha deve conter pelo menos uma letra minúscula');
  } else if (/[a-z]/.test(password)) {
    strengthScore += 1;
  }

  // Verificar números
  if (requireNumbers && !/\d/.test(password)) {
    errors.push('A senha deve conter pelo menos um número');
  } else if (/\d/.test(password)) {
    strengthScore += 1;
  }

  // Verificar caracteres especiais
  if (requireSpecialChars) {
    const specialCharRegex = new RegExp(`[${specialChars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}]`);
    if (!specialCharRegex.test(password)) {
      errors.push(`A senha deve conter pelo menos um caractere especial (${specialChars})`);
    } else {
      strengthScore += 1;
    }
  }

  // Verificações adicionais para força da senha
  if (password.length >= 12) strengthScore += 1;
  if (/(.)\1{2,}/.test(password)) strengthScore -= 1; // Penalizar repetições
  if (/^(.{1,2})\1+$/.test(password)) strengthScore -= 2; // Penalizar padrões simples

  // Determinar força da senha
  let strength: 'weak' | 'medium' | 'strong';
  if (strengthScore <= 2) {
    strength = 'weak';
  } else if (strengthScore <= 4) {
    strength = 'medium';
  } else {
    strength = 'strong';
  }

  return {
    isValid: errors.length === 0,
    errors,
    strength
  };
};

/**
 * Gera uma senha aleatória segura
 * @param length - Comprimento da senha (padrão: 12)
 * @param options - Opções para geração da senha
 * @returns Senha gerada
 */
export interface PasswordGenerationOptions {
  includeUppercase?: boolean;
  includeLowercase?: boolean;
  includeNumbers?: boolean;
  includeSpecialChars?: boolean;
  specialChars?: string;
  excludeSimilar?: boolean; // Excluir caracteres similares como 0, O, l, I
}

export const generatePassword = (
  length: number = 12,
  options: PasswordGenerationOptions = {}
): string => {
  const {
    includeUppercase = true,
    includeLowercase = true,
    includeNumbers = true,
    includeSpecialChars = true,
    specialChars = '!@#$%^&*()_+-=[]{}|;:,.<>?',
    excludeSimilar = true
  } = options;

  let charset = '';
  
  if (includeUppercase) {
    charset += excludeSimilar ? 'ABCDEFGHJKLMNPQRSTUVWXYZ' : 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  }
  
  if (includeLowercase) {
    charset += excludeSimilar ? 'abcdefghijkmnopqrstuvwxyz' : 'abcdefghijklmnopqrstuvwxyz';
  }
  
  if (includeNumbers) {
    charset += excludeSimilar ? '23456789' : '0123456789';
  }
  
  if (includeSpecialChars) {
    charset += specialChars;
  }

  if (charset === '') {
    throw new Error('Pelo menos um tipo de caractere deve ser incluído');
  }

  let password = '';
  for (let i = 0; i < length; i++) {
    password += charset.charAt(Math.floor(Math.random() * charset.length));
  }

  return password;
}; 